export default __webpack_public_path__ + "static/media/modalfooter.33bf0d77.png";